module.exports = __webpack_public_path__ + "static/media/to_configure_36980.6983dd1b.png";